module.exports = __webpack_public_path__ + "img/image1x2.0dda95b7.jpg";